import { HttpErrorResponse } from '@angular/common/http';

/** What the login page says when sign-in fails; a 429 carries the API's wait time */
export function loginErrorMessage(error: HttpErrorResponse): string {
  if (error.status === 401) return 'Invalid Credentials';
  if (error.status === 429) return error.error?.message || 'Too many sign-in attempts. Please try again later.';
  return 'Internal Server Error. Please try again later.';
}
